/**
 * Temporary hardcode. browse-page-banner does not send shouldRefresh for this banner,
 * but the landing page is not an SPA route and needs a full document load.
 */
const HARD_REFRESH_BANNER_NAMES = new Set(['Big Gold Upgrade']);

export function shouldHardRefreshBanner(name: string | null | undefined): boolean {
  return HARD_REFRESH_BANNER_NAMES.has((name ?? '').trim());
}
